import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Center, Text } from "native-base";
import React from "react";

import RoundedIcon from "@/components/atoms/RoundedIcon";

const EmptyList = () => {
  return (
    <Center>
      <RoundedIcon icon={<MaterialCommunityIcons name="cart-off" />} />
      <Text fontSize="lg" pt="8">
        Nenhum dado encontrado!
      </Text>
    </Center>
  );
};

export default EmptyList;
